module.exports = __webpack_public_path__ + "img/Shva_correct.5bca8fec.png";